
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class BatteryBaseMock extends Vue {
  batteryState = 100
}
